import { styled, Typography } from '@mui/material';

const StyledAppbarUsername = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 500,
  lineHeight: theme.typography.pxToRem(18)
}));

export default StyledAppbarUsername;
